import { render, staticRenderFns } from "./HotpointAudio.vue?vue&type=template&id=61caefb8&scoped=true"
import script from "./HotpointAudio.vue?vue&type=script&lang=js"
export * from "./HotpointAudio.vue?vue&type=script&lang=js"
import style0 from "./HotpointAudio.vue?vue&type=style&index=0&id=61caefb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61caefb8",
  null
  
)

export default component.exports